import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { stamfordConfig } from "./data";

export default function StamfordPage() {
  return <CityPageTemplate config={stamfordConfig} />;
}